import { getCalcInputState } from "../../../../../utils/selectors";
import { jackSlice } from "./slice";

export const getJackState = state => getCalcInputState(state)[jackSlice.name];